import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {Router, Route, browserHistory, IndexRedirect} from 'react-router'
import StepOne from './StepOne';
import ChooseServices from './ChooseServices';
import StepTwo from './StepTwo';
import StepThree from './StepThree';
import StepFour from './StepFour';
import ForgotPassword from './ForgotPassword';
import MyAccount from './MyAccount';

ReactDOM.render(
    <Router history={browserHistory}>
        <Route path="/" component={App}>
            <IndexRedirect to='/StepOne'/>
            <Route path="/StepOne" component={StepOne}/>
            <Route path="/ChooseServices" component={ChooseServices}/>
            <Route path="/StepTwo" component={StepTwo}/>
            <Route path="/StepThree" component={StepThree}/>
            <Route path="/StepFour" component={StepFour}/>
            <Route path="/ForgotPassword" component={ForgotPassword}/>
            <Route path="/MyAccount" component={MyAccount}/>
        </Route>
    </Router>,
    document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/